import React from "react";
import HighlightIcon from "@mui/icons-material/Highlight";

export default function Header() {
  return (
    <header>
      <h1>
        <HighlightIcon />
        Advanced ToDoList
      </h1>
    </header>
  );
}
